import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Day from "./views/Day"
import Dashboard from "./views/Dashboard"

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/day/:day?',
      name: 'day',
      component: Day, // or lazy load () => import('./views/Day.vue')
    },
    {
      path: '/dashboard/:type',
      name: 'dashboard',
      component: Dashboard,
    }
  ]
})
